import { render, staticRenderFns } from "./ChatsResultados.vue?vue&type=template&id=3e2b4154&scoped=true&"
import script from "./ChatsResultados.vue?vue&type=script&lang=js&"
export * from "./ChatsResultados.vue?vue&type=script&lang=js&"
import style0 from "./ChatsResultados.vue?vue&type=style&index=0&id=3e2b4154&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e2b4154",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCheckbox,VCol,VDataTable,VIcon,VRow,VTextField})
